(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("VectorMap", [], factory);
	else if(typeof exports === 'object')
		exports["VectorMap"] = factory();
	else
		root["VectorMap"] = factory();
})(this, function() {
return 